import { dayjs } from '@mobi/utils/date'
import type {
  SearchResult,
  SearchResultAcceptor,
  SearchResultRace,
  SearchResultFobEvent,
  SearchResultFobProposition,
} from '@core/Areas/Search/types'
import {
  isSearchResultAcceptor,
  isSearchResultFobEvent,
  isSearchResultFobProposition,
  isSearchResultRace,
} from '@core/Areas/Search/helpers/typeGuards'

export function getRedirectUrl(searchResult: SearchResult): string {
  if (isSearchResultAcceptor(searchResult)) {
    const acceptorResult = searchResult as SearchResultAcceptor
    return `/tote/meetings/${acceptorResult.acceptor.race.fixture.id}/${acceptorResult.acceptor.race.number}?date=${acceptorResult.acceptor.race.fixture.date}`
  }

  if (isSearchResultRace(searchResult)) {
    const raceResult = searchResult as SearchResultRace
    return `/tote/meetings/${raceResult.race.fixture.id}/${raceResult.race.number}?date=${raceResult.race.fixture.date}`
  }

  if (isSearchResultFobEvent(searchResult)) {
    const { fobEvent } = searchResult as SearchResultFobEvent
    if (!fobEvent) return '/'

    const { startTime, productCode, contestType, sequence, competitionSeq } = fobEvent
    const date = dayjs(startTime).format('YYYY-MM-DD')

    if (productCode === 'FR')
      return `/fobracing/propositions/FR/${contestType}/${sequence}?selectiondate=${date}`
    if (productCode === 'CLG')
      return `/fobracing/propositions/CLG/${contestType}/${sequence}?selectiondate=${date}`
    if (productCode === 'FOO')
      return `/fobracing/propositions/FOO/${contestType}/${sequence}?selectiondate=${date}&meetingSeq=${competitionSeq}`
    if (productCode === 'FFF')
      return `/fobracing/propositions/FFF/${contestType}/${sequence}?selectiondate=${date}&meetingSeq=${competitionSeq}`

    return `/`
  }

  if (isSearchResultFobProposition(searchResult)) {
    const { fobProposition } = searchResult as SearchResultFobProposition
    const { contestType, productCode, sequence, startTime, competitionSeq } =
      fobProposition.fobEvent
    const date = dayjs(startTime).format('YYYY-MM-DD')

    return `/fobracing/propositions/${productCode}/${contestType}/${sequence}?selectiondate=${date}&meetingSeq=${competitionSeq}`
  }

  return ''
}
